import { stateStatusType, ModuleProps } from './actionType';

// getModulesState
export interface GetModulesState {
    isLoading: boolean;
    error: string | null;
    modules: ModuleProps[] | null;
    status: stateStatusType | null;
}

export const initialGetModulesState: GetModulesState = {
    isLoading: false,
    error: null,
    modules: null,
    status: null
};

export interface ModulesState {
    getModulesState: GetModulesState;
}

export const initialState: ModulesState = {
    getModulesState: initialGetModulesState,
};
